<div class="p-1 overflow-auto" style="height: 800px">
  <div class="flex justify-content-between my-2 align-items-center">
    <h3 class="m-0 text-lg">{{ riskManagementSupplier.supplierName }}</h3>
    <assigned-to
      (assignedUserChange)="handleAssigneeChanged($event)"
      [assigneeId]="riskManagementSupplier.assigneeId"
    ></assigned-to>
  </div>
  <div class="flex flex-wrap gap-3 align-items-center">
    <app-supplier-classification
      [supplierOperationalData]="riskManagementSupplier.supplierClassification"
    ></app-supplier-classification>
    <span class="flex align-items-center">
      <i class="fa fa-home mr-2 text-gray-700"></i>
      {{ riskManagementSupplier.supplierHomePostcode }}
    </span>
    <span class="flex align-items-center">
      <i class="fa fa-phone mr-2 text-gray-700"></i>
      <span class="text-blue-500">{{ riskManagementSupplier.supplierPhoneNumber }}</span>
    </span>
  </div>

  <div *ngIf="riskManagementSupplier.tasks.length" class="mt-2">
    <div
      [style.height.px]="300"
      style="border-radius: 10px; overflow: hidden; margin-bottom: 7px; width: 100%"
    >
      <map-control-v2
        [taskIds]="taskIds"
        [displayTaskLegends]="true"
        (taskClicked)="changeSelectedTask($event.taskId)"
      ></map-control-v2>
    </div>

    <div>
      <div class="mb-3" *ngFor="let task of riskManagementSupplier.tasks; trackBy: trackByTaskId">
        <risk-management-selected-supplier-task
          [supplierTask]="task"
          (reviewStatusChange)="handleReviewStatusChange($event)"
        ></risk-management-selected-supplier-task>
      </div>
      <div class="my-8"></div>
    </div>
  </div>
  <div *ngIf="!riskManagementSupplier.tasks.length" class="mt-2">
    This supplier has no tasks today.
  </div>
</div>
